import style from "./account.module.scss";
import packageJson from "../../../package.json";
import { useMsal } from "@azure/msal-react";
import { useDxp } from "../../authConfig";

const version = packageJson.version;

const Logout = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    localStorage.removeItem("tgt");
    localStorage.removeItem("authIDu");

    if (useDxp) {
      instance
        .logoutRedirect()
        .then((response) => {
          console.log(response);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch("https://tgldcdp.tg.org.au/userlogout", {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((data) => {
          console.log(data);
          if (data.ok) window.location.reload(true);
        })
        .catch((error) => console.error("Error:", error));
    }
  };

  return (
    <div className={style.logout}>
      <button className={style.logoutButton} onClick={handleLogout}>
        Logout
      </button>
      <p className={style.version}>v&nbsp;{version}</p>
    </div>
  );
};

export default Logout;
